<template>
  <div>
    <div class="col-md-2">
      <div id="accordion">
        <div class="card">
          <div class="card-header" id="headingOne">
            <button class="btn btn-link">
              Data filters
            </button>
          </div>

          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordion"
          >
            <div class="card-body">
              <div class="filter-group">
                <div v-for="filter in dataFilters" :key="filter.id">
                  <div class="radio-input">
                    <input
                      @click="changeFilter($event, 'data')"
                      type="radio"
                      name="dataFilters"
                      :id="filter.id"
                      :value="filter.id"
                      :class="{
                        disabled:
                          (!isReportWithUsers(selectedFilters['report']) ||
                            selectedFilters['report'] === 'registrations') &&
                          filter.id === 'users'
                      }"
                      checked
                    />
                    <label :for="filter.id">{{ filter.name }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingTwo">
            <button class="btn btn-link">
              Client filters
            </button>
          </div>

          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordion"
          >
            <div class="card-body">
              <div class="filter-group">
                <div v-for="filter in clientFilters" :key="filter.id">
                  <div class="radio-input">
                    <input
                      @click="changeFilter($event, 'client')"
                      type="radio"
                      name="clientFilters"
                      :id="filter.id"
                      :value="filter.id"
                      checked
                    />
                    <label :for="filter.id">{{ filter.name }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingThree">
            <button class="btn btn-link">
              Report filters
            </button>
          </div>

          <div
            id="collapseThree"
            class="collapse show"
            aria-labelledby="headingThree"
            data-parent="#accordion"
          >
            <div class="card-body">
              <div class="filter-group">
                <div v-for="filter in reportFilters" :key="filter.id">
                  <div class="radio-input">
                    <input
                      @click="changeFilter($event, 'report')"
                      type="radio"
                      name="reportFilters"
                      :id="filter.id"
                      :value="filter.id"
                      checked
                    />
                    <label :for="filter.id">{{ filter.name }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingFour">
            <button class="btn btn-link">
              Time filters
            </button>
          </div>

          <div
            id="collapseFour"
            class="collapse show"
            aria-labelledby="headingFour"
            data-parent="#accordion"
          >
            <div class="card-body">
              <div class="filter-group">
                <div v-for="filter in timeFilters" :key="filter.id">
                  <div class="radio-input">
                    <input
                      @click="changeFilter($event, 'time')"
                      type="radio"
                      name="timeFilters"
                      :id="filter.id"
                      :value="filter.id"
                      checked
                    />
                    <label :for="filter.id">{{ filter.name }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-10 reports-data">
      <div>
        <div class="report-calendar">
          <date-picker
            lang="en"
            placeholder="Select Date"
            :disabled-date="notAfterToday"
            v-model="reportDate"
            input-class="form-control"
            @input="getReportByDate"
          ></date-picker>
        </div>
        <div class="date-title">
          Report Generated On: {{ parseDate(reportDate) }}
        </div>
        <div class="date-title">
          The shown data is for the following range:
          {{ parseDate(reportDate) }} -
          {{ getReportDateBasedOnFilter() }}
        </div>
      </div>
      <div class="loader-div" v-if="reportBusy">
        <!--        <loader :size="'8px'"></loader>-->
        <span class="insteadLoader"
          >CREATING REPORT ,PLEASE WAIT
          <div class="snippet" data-title=".dot-flashing">
            <div class="stage">
              <div class="dot-flashing"></div>
            </div>
          </div>
        </span>
      </div>
      <div v-if="!Array.isArray(report) && !reportBusy">
        <div
          class="data-tables"
          v-if="withUserReport.includes(selectedFilters['report'])"
        >
          <div
            v-for="item in report[selectedFilters['time']][
              selectedFilters['report']
            ]['all_data'][selectedFilters['client']].slice(0, 3)"
            :key="item"
          >
            <table>
              <thead>
                <tr>
                  <th></th>
                  <th>Count</th>
                  <th>%</th>
                  <th>Total</th>
                  <th>%</th>
                </tr>
              </thead>
              <tbody>
                <tr class="header-tr">
                  <td>
                    {{ getItemHeader(item, selectedFilters["report"]) }}
                    <span
                      class="report-rank"
                      v-for="rank in item.rankings"
                      :key="rank"
                      v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                    >
                      <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                        {{ rank["id"] }}:{{ rank["rank"] }}|
                      </span>
                    </span>
                  </td>
                  <td>{{ item.total }}</td>
                  <td>
                    {{
                      ((100 * item.total) / item.total_in_time_frame).toFixed(2)
                    }}
                  </td>
                  <td>{{ item.total_in_time_frame }}</td>
                  <td></td>
                </tr>
                <tr
                  v-for="data in item[selectedFilters['data']].slice(0, 3)"
                  :key="data"
                >
                  <td>
                    <span
                      v-if="
                        selectedFilters['data'] === 'users' &&
                          salesPersonList.find(user => user.id === data.id)
                      "
                    >
                      {{
                        salesPersonList.find(user => user.id === data.id)
                          .full_name
                      }}
                    </span>
                    <span v-else-if="selectedFilters['data'] === 'country_id'">
                      {{
                        dictionaries.general.countries.find(
                          country => country.id === data.id
                        ).name
                      }}
                    </span>
                    <span v-else>
                      {{ data.id }}
                    </span>
                    <span
                      class="report-rank"
                      v-for="rank in data.rankings"
                      :key="rank"
                      v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                    >
                      <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                        {{ rank["id"] }}:{{ rank["rank"] }}|
                      </span>
                    </span>
                  </td>
                  <td>{{ data.amount }}</td>
                  <td>
                    {{
                      ((100 * data.amount) / item.total_in_time_frame).toFixed(
                        2
                      )
                    }}
                  </td>
                  <td>{{ item.total_in_time_frame }}</td>
                  <td>{{ ((100 * data.amount) / item.total).toFixed(2) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          class="data-tables"
          v-if="specialReports.includes(selectedFilters['report'])"
        >
          <div>
            <table>
              <thead>
                <tr>
                  <th></th>
                  <th>Count</th>
                  <th>%</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="data in report[selectedFilters['time']][
                    selectedFilters['report']
                  ]['all_data'][selectedFilters['client']][
                    selectedFilters['data']
                  ].slice(0, 3)"
                  :key="data"
                >
                  <td>
                    <span
                      v-if="
                        selectedFilters['data'] === 'users' &&
                          salesPersonList.find(user => user.id === data.id)
                      "
                    >
                      {{
                        salesPersonList.find(user => user.id === data.id)
                          .full_name
                      }}
                    </span>
                    <span v-else-if="selectedFilters['data'] === 'country_id'">
                      {{
                        dictionaries.general.countries.find(
                          country => country.id === data.id
                        ).name
                      }}
                    </span>
                    <span v-else>
                      {{ data.id }}
                    </span>
                    <span
                      class="report-rank"
                      v-for="rank in data.rankings"
                      :key="rank"
                      v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                    >
                      <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                        {{ rank["id"] }}:{{ rank["rank"] }}|
                      </span>
                    </span>
                  </td>
                  <td>{{ data.amount }}</td>
                  <td>
                    {{
                      ((100 * data.amount) / getTotalBasedOnReport()).toFixed(2)
                    }}
                  </td>
                  <td>
                    {{ getTotalBasedOnReport() }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import apiClientCreator from "../../../../helpers/api/request";
import Loader from "../../../../main/misc.main/loader/Loader";
import DatePicker from "vue2-datepicker";
import {mapGetters, mapState} from "vuex";
import UsersPermissionCheck from "../../../../mixins/user/auth/UsersPermissionCheck";

export default {
  name: "StatsRedo.container",
  components: {
    DatePicker
    // Loader
  },

  mixins: [UsersPermissionCheck],

  data() {
    return {
      report: [],
      reportDate: moment(),
      reportBusy: false,
      selectedFilters: {
        client: "ALL",
        data: "country_id",
        report: "scheduled_call_auto_status",
        time: 90
      },
      noUserReports: [
        "no_answer_agents",
        "transferred_to",
        "transferred_to_live",
        "transferred_to_online",
        "assigned_agents"
      ],
      withUserReport: [
        "scheduled_call_status",
        "scheduled_call_auto_status",
        "not_interested_reasons",
        "bad_number_reasons",
        "brokers",
        "keywords",
        "campaigns",
        "second_voice",
        "no_answer_agents",
        "transferred_to",
        "transferred_to_live",
        "transferred_to_online",
        "assigned_agents"
      ],
      specialReports: [
        "deposits",
        "not_interested_leads",
        "not_reached",
        "registrations",
        "cc_decline_deposits"
      ],
      dataFilters: [
        {
          id: "users",
          name: "AGENTS"
        },
        {
          id: "campaign_aaid",
          name: "CAMPAIGNS"
        },
        {
          id: "keyword",
          name: "KEYWORDS"
        },
        {
          id: "country_id",
          name: "COUNTRIES"
        }
      ],
      clientFilters: [
        {
          id: "REG",
          name: "REG"
        },
        {
          id: "DUP",
          name: "DUP"
        },
        {
          id: "ALL",
          name: "ALL"
        }
      ],
      timeFilters: [
        {
          id: 1,
          name: "YESTERDAY"
        },
        {
          id: 30,
          name: "30 DAYS"
        },
        {
          id: 90,
          name: "90 DAYS"
        }
      ],
      reportFilters: [
        {
          id: "assigned_agents",
          name: "ASSIGNED AGENTS"
        },
        {
          id: "transferred_to",
          name: "TRANSFERRED TO"
        },
        {
          id: "transferred_to_live",
          name: "TRANSFERRED TO LIVE"
        },
        {
          id: "transferred_to_online",
          name: "TRANSFERRED TO ONLINE"
        },
        {
          id: "no_answer_agents",
          name: "NO ANSWER"
        },
        {
          id: "not_interested_leads",
          name: "NOT INTERESTED LEADS"
        },
        {
          id: "not_interested_reasons",
          name: "NOT INTERESTED REASONS"
        },
        {
          id: "bad_number_reasons",
          name: "BAD NUMBER REASONS"
        },
        {
          id: "campaigns",
          name: "CAMPAIGNS"
        },
        {
          id: "keywords",
          name: "KEYWORDS"
        },
        {
          id: "brokers",
          name: "BROKERS"
        },
        {
          id: "second_voice",
          name: "SECOND VOICE"
        },
        {
          id: "deposits",
          name: "DEPOSITS"
        },
        {
          id: "cc_decline_deposits",
          name: "CC-DECLINE"
        },
        {
          id: "registrations",
          name: "REGISTRATIONS"
        },
        {
          id: "not_reached",
          name: "NOT REACHED"
        },
        {
          id: "scheduled_call_status",
          name: "SCHEDULED CALLS"
        },
        {
          id: "scheduled_call_auto_status",
          name: "SCHEDULED CALLS AUTO"
        }
      ]
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", [ "dictionaries", "salesPersonList"])
  },
  created() {
    this.getReportByDate(moment().format("YYYY-MM-DD"));
  },
  methods: {
    changeFilter(event, group) {
      if (
        (!this.isReportWithUsers(event.target.value) ||
          event.target.value === "registrations") &&
        group === "report"
      ) {
        if (this.selectedFilters["data"] === "users") {
          this.selectedFilters["data"] = "campaign_aaid";
        }
      }
      this.selectedFilters[group] = event.target.value;
    },
    parseDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    getReportDateBasedOnFilter() {
      return moment(this.reportDate)
        .subtract(this.selectedFilters["time"], "days")
        .format("YYYY-MM-DD");
    },
    isReportWithUsers(reportType) {
      return !this.noUserReports.includes(reportType);
    },
    getTotalBasedOnReport() {
      return this.selectedFilters["report"] === "cc_decline_deposits"
        ? this.report[this.selectedFilters["time"]][
            this.selectedFilters["report"]
          ]["all_data"][this.selectedFilters["client"]]
            .total_deposits_in_time_frame
        : this.report[this.selectedFilters["time"]][
            this.selectedFilters["report"]
          ]["all_data"][this.selectedFilters["client"]].total_in_time_frame;
    },
    notAfterToday(date) {
      return date > moment();
    },
    getTotalInTimeFrameBasedOnReport() {
      if (!Array.isArray(this.report)) {
        if (this.withUserReport.includes(this.selectedFilters["report"])) {
          let total = 0;
          if (
            this.report[this.selectedFilters["time"]][
              this.selectedFilters["report"]
            ]["all_data"][this.selectedFilters["client"]].length > 0
          ) {
            total = this.report[this.selectedFilters["report"]]["all_data"][
              this.selectedFilters["client"]
            ][0].total_in_time_frame;
          }
          return total;
        } else {
          return this.getTotalBasedOnReport();
        }
      }
    },
    getItemHeader(item, reportType) {
      let header;
      switch (reportType) {
        case "scheduled_call_status":
          header = item.status.type;
          break;
        case "scheduled_call_auto_status":
          header = item.status.type;
          break;
        case "not_interested_reasons":
          header = this.dictionaries.activity.not_int_states.find(
            state => state.id === item.id
          ).name;
          break;
        case "bad_number_reasons":
          header = this.dictionaries.activity.bad_number_states.find(
            state => state.id === item.id
          ).name;
          break;
        case "brokers":
          header = this.dictionaries.general.brokers.find(
            broker => broker.id === item.id
          ).name;
          break;
        case "keywords":
          header = item.id;
          break;
        case "campaigns":
          header = item.id;
          break;
        case "no_answer_agents":
        case "transferred_to":
        case "transferred_to_live":
        case "transferred_to_online":
        case "assigned_agents":
          header =
            this.salesPersonList.find(user => user.id === item.id) === undefined
              ? item.id
              : this.salesPersonList.find(user => user.id === item.id)
                  .full_name;
          break;
      }
      return header === undefined ? item.id : header;
    },
    async getReportByDate(timeFrame) {
      timeFrame = moment(timeFrame).format("YYYY-MM-DD");
      if (this.CheckUserPermission([1, 2, 3, 4, 12])) {
        try {
          this.reportBusy = true;
          const res = await apiClientCreator(
            `reports/all_timely_report_by_date/${timeFrame}`
          ).get("");
          this.report = res.data;
          this.reportBusy = false;
        } catch (e) {}
      }
    }
  }
};
</script>

<style scoped>
table tr:hover {
  background: #eceff1;
}
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 0.5em 0.4em;
}
th {
  font-size: smaller;
}
.btn-link {
  width: 100%;
  color: #fff;
  background-color: #337ab7;
  border-color: #2e6da4;
}
.btn-link,
.btn-link:hover,
.btn-link:focus {
  text-decoration: none;
  outline: none;
}
input[type="radio"] {
  margin: 3px 5px 0;
}

.radio-input {
  display: flex;
  font-size: 0.7vw;
  background-color: lightgrey;
  border: 1px solid grey;
  border-top: none;
}
.header-tr {
  border-bottom: 10px solid transparent;
}
.data-tables {
  display: flex;
  justify-content: space-around;
  padding-top: 3em;
}
.disabled {
  pointer-events: none;
  opacity: 0.2;
}
.report-calendar {
  display: flex;
  justify-content: center;
}
.reports-data {
  padding-top: 2em;
}
.loader-div {
  padding-top: 7em;
}
.date-title {
  display: flex;
  justify-content: center;
  padding-top: 2em;
}
/**
 * ==============================================
 * Dot Flashing
 * ==============================================
 */
.dot-flashing {
  position: relative;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite linear alternate;
  animation-delay: 0.5s;
}

.dot-flashing::before,
.dot-flashing::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}

.dot-flashing::before {
  left: -15px;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 0s;
}

.dot-flashing::after {
  left: 15px;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 1s;
}

@keyframes dotFlashing {
  0% {
    background-color: red;
  }
  50%,
  100% {
    background-color: #ebe6ff;
  }
}
.stage {
  position: absolute;
  left: 110%;
  top: 48%;
}
.insteadLoader {
  color: red;
  position: absolute;
  left: 35%;
  top: 158px;
}
</style>
